<template>
    <teleport to="body">
        <div class="file-uploader-modal" :class="{'is-uploading': is_uploading}">
            <div class="inner">
                <div v-if="! is_uploading" class="head">
                    <div class="label">Select an activity</div>
                    <select class="form-control" v-model="value.activity_id">
                        <option v-for="activity in activities" :key="activity.id" :value="activity.id">
                            {{ activity.activity.name }}
                        </option>
                        <option :value="null">Additional Uploads</option>
                    </select>
                    <div class="close" @click="close()">&times;</div>
                </div>
                <div class="body mb-3">
                    <file-uploader v-model="value.file"
                                   @uploadstart="is_uploading = true"
                                   @uploadend="is_uploading = false"
                                   @change="fileChanged()" />
                </div>
                <div v-if="! is_uploading" class="foot d-flex justify-content-center">
                    <button class="btn"
                            :style="{backgroundColor: color, color: 'white'}"
                            @click="save()">Save</button>
                </div>
            </div>
        </div>
    </teleport>
</template>

<script>
import {mapGetters} from "vuex";
import utils from "@/mixins/utils";

import ColorButton from "@/Components/Canvas2/ColorButton";
import Input from "@/Jetstream/Input";
import FileUploader from "@/Components/Canvas2/FileUploader";

export default {
    name: "ActivityFileUploaderModal",
    components: {FileUploader, Input, ColorButton},
    mixins: [utils],
    emits: ['close', 'update:modelValue', 'change'],

    props: {

        modelValue: {
            type: Object,
            // default: () => ({
            //     id: null,
            //     file: null,
            //     activity_id: null,
            // }),
        },

        color: {
            type: String,
            default: '#333333',
        },

        stage:{
            type: String,
        }
    },


    data(){
        return {

            is_uploading: false,

            value: {
                id: null,
                file: null,
                activity_id: null,
                options: {width: 1},
            },
        }
    },


    computed: {
        ...mapGetters('canvas2', [
            'getPathActivitiesOnlyByStage',
            'getPathActivitiesWithoutCanvasUploadsByStage'
        ]),

        activities(){
            return this.getPathActivitiesOnlyByStage( this.stage );
        },

        incomplete_activities(){
            return this.getPathActivitiesWithoutCanvasUploadsByStage( this.stage );
        },

        first_incomplete_activity(){
            return this.incomplete_activities.length > 0 ? this.incomplete_activities[0] : null;
        }

    },

    methods: {

        close(){
            this.$emit('close');
        },

        fileChanged(){
            this.value.id = this.utils.randomId({prefix: 'file'});
        },

        save(){
            this.$emit('update:modelValue', this.value);
            this.$emit('change', this.value);
            this.close();
        },
    },

    beforeMount() {
        if( this.activities.length ){
            this.value.id = this.activities[0].id;
        }
    },

    mounted() {
        this.value.activity_id = this.first_incomplete_activity?.id ?? (this.activities.length ? this.activities[0].id : null);
    }

}
</script>

<style lang="scss" scoped>
.file-uploader-modal{
    background: rgba(black, 0.3);
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 99999;

    .inner{
        border-radius: .3rem;
        position: fixed;
        max-width: 800px;
        width: 90%;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        background: white;
        padding: 1rem;
    }

    .head{
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 1rem;
        padding-right: 2rem;

        .form-control{
            width: auto;
        }

        .label{
            font-weight: $font-weight-bold;
            font-size: 1rem;
            white-space: nowrap;
            margin-right: 1rem;
        }

        .close{
            position: absolute;
            right: 0.4rem;
            top: 0.4rem;
            background: black;
            color: white;
            width: 2rem;
            height: 2rem;
            font-size: 1rem;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            cursor: pointer;

            &:hover{
                background-color: $danger;
                opacity: 1;
            }
        }
    }

}
</style>
